import { useContext } from "react";
import { BalansGoods } from "Context/context";

export default function useDeliveryBalansGoods() {
  return useContext(BalansGoods);
}
